<template>
  <div>
    <WsCreate
      ref="WsCreate"
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :primary="pageSetting.primary"
      :secondary="pageSetting.secondary"
      v-model="updateData"
      :emitSubmit="true"
      @submit="$_onSubmit()"
    >
    </WsCreate>
    <WsMain v-if="tulpaSectionTemplate">
      <WsCard>
        <WsTitle size="5">區塊內容</WsTitle>
        <WsState
          class="mt-20"
          type="form"
          :fields="tulpaSectionTemplate.fields"
          v-model="state.content"
        ></WsState>
      </WsCard>
    </WsMain>
  </div>
</template>

<script>
import model from "@/__vue2stone_cms/models/tulpa_section";
export default {
  metaInfo() {
    return {
      title: "建立區塊",
    };
  },

  data: () => ({
    updateData: null,
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "stateCard",
          floors: [
            {
              fields: ["tulpa_section_template", "name"],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "stateCard",
          floors: [
            {
              title: "設定",
              fields: ["tags", "remark"],
            },
          ],
        },
      ],
    },
    tulpaSectionTemplate: null,
    state: {
      content: {},
    },
  }),

  methods: {
    async $_onSubmit() {
      const postData = JSON.parse(JSON.stringify(this.updateData));
      postData.content = this.state.content;
      try {
        this.$refs.WsCreate.loadingStart();
        await this.$axios.post("tulpa_section", postData);
        this.$router.push("/tulpa_section");
      } catch (error) {
        console.log(error);
        alert("儲存錯誤");
      } finally {
        this.$refs.WsCreate.loadingStop();
      }
    },
    async $_fetchTulpaSectionTemplate() {
      const res = await this.$axios.get(
        `tulpa_section_template/${this._tulpaSectionTemplateId}`
      );
      this.tulpaSectionTemplate = res.data.data;
    },
  },

  watch: {
    _tulpaSectionTemplateId: {
      handler() {
        if (this._tulpaSectionTemplateId) {
          this.$_fetchTulpaSectionTemplate();
        } else {
          this.tulpaSectionTemplate = null;
        }
      },
    },
  },

  computed: {
    _tulpaSectionTemplateId() {
      if (!this.updateData) {
        return null;
      }
      return this.updateData.tulpa_section_template;
    },
  },
};
</script>

<style>
</style>